import { DELETE } from "../../../helper/xbi4RestFunctions";

const deleteProjectMember = async (
  orgId: any,
  projectId: any,
  projectMemberId: any
) => {
  const path = `/orgs/${orgId}/projects/${projectId}/members/${projectMemberId}/remove`;
  return await DELETE(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching modules > ", err);
      return err;
    });
};

export default deleteProjectMember;
